import script from "./ParsleyItemPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsleyItemPicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
script.components = Object.assign({}, { InputField, NeueButton }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputField, NeueButton }, script.__o.components);}